<template>
    <div class="app-left-content-header">
        <h1 class="content-title">Aplicaciones en Sistema</h1>
    </div>

    <div class="app-content-field">
        <div class="app-boxes">
            <div class="app-box-wrapper three">
                <div class="app-box medium">
                    <img class="app-box-image" src="../assets/bg3.jpg" alt="app" />
                    <div class="app-box-details">
                        <div class="details-left">
                            RH
                        </div>
                        <div class="details-right">
                            <i class="bi bi-arrow-right-circle"></i>
                        </div>
                    </div>
                </div>
                <div class="app-box medium">
                    <img class="app-box-image" src="../assets/logoSquare.png" alt="app" />
                    <div class="app-box-details">
                        <div class="details-left">
                            Mantenimiento
                        </div>
                        <div class="details-right">
                            <i class="bi bi-arrow-right-circle"></i>
                        </div>
                    </div>
                </div>
                <div class="app-box medium">
                    <img class="app-box-image"
                        src="https://images.unsplash.com/photo-1526827826797-7b05204a22ef?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1234&q=80"
                        alt="app" />
                    <div class="app-box-details">
                        <div class="details-left">
                            Operaciones
                        </div>
                        <div class="details-right">
                            <i class="bi bi-arrow-right-circle"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="app-content-footer">
        <div class="app-footer-left">
            <button class="logout-button" @click="authStore.logout(router)">Cerrar Sesión</button>
        </div>
        <div class="app-footer-right">
            <button class="admin-button">
                <router-link to="/admin-panel">
                    Panel de Administración
                </router-link>
            </button>
            <button class="change-password-button">
                <router-link to="/change-password">
                    Cambiar Contraseña
                </router-link>
            </button>
        </div>
    </div>
    <div class="app-content-footer-mobile">
        <button class="options-menu"><i class="bi bi-three-dots-vertical"></i></button>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
const router = useRouter();

console.log(authStore);



</script>

<style scoped>
.app-left-content {
    height: 82%;
}

.app-content-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    margin-bottom: 32px;
    position: absolute;
    bottom: 30px;
    left: 90px;
    right: 90px;
}

.app-footer-left {
    display: flex;
    align-items: center;
}

.app-footer-right {
    display: flex;
    align-items: center;
    gap: 16px;
}

.logout-button {
    background-color: #e74c3c;
    color: #ffffff;
    border: none;
    border-radius: 30px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.logout-button:hover {
    background-color: #c0392b;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.admin-button {
    background-color: #0c4a6c;
    color: #ffffff;
    border: none;
    border-radius: 30px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.admin-button:hover {
    background-color: #536c82;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.change-password-button {
    background-color: #f5b42c;
    color: #ffffff;
    border: none;
    border-radius: 30px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.change-password-button:hover {
    background-color: #f4c46f;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.app-content-footer-mobile {
    display: none;
}

/* Estilos para pantallas pequeñas */
@media screen and (max-width: 768px) {
    .app-left-content {
        height: 100%;
    }

    .app-content-footer {
        display: none;
    }

    .app-content-footer-mobile {
        display: flex;
        justify-content: left;
        position: absolute;
        bottom: 30px;
        left: 30px;
    }

    .options-menu {
        background-color: #171a24;
        color: #ffffff;
        border: none;
        border-radius: 50%;
        padding: 15px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.3s ease;
        box-shadow: 0 0 5px rgba(26, 79, 214, 0.748);
    }
}

/* estilos para pantallas mayores a 1200px */
@media screen and (min-width: 1200px) {
    .app-content-footer {
        left: 110px;
        right: 110px;
        bottom: 40px;
    }
}
</style>